import UiTheme from "shared/enums/UiTheme";
import { ThemeVariable } from "shared/utils/enums";

export const ThemeList = [
  {
    name: UiTheme.BLACK,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#fff3f9",
      [ThemeVariable.ACTIVE]: "#fff3f9",
      [ThemeVariable.PRIMARY]: "#1B1B1C",
      [ThemeVariable.SECONDARY]: "#E74E9A",
      [ThemeVariable.PRIMARY_LIGHT]: "#fff3f9",
      [ThemeVariable.PRIMARY_LIGHTER]: "#FAFAFA",
      [ThemeVariable.PRIMARY_RGB]: "27,27,28",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "231,78,154"
    }
  },
  {
    name: UiTheme.BLUE,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#ECEEF9",
      [ThemeVariable.ACTIVE]: "#ECEEF9",
      [ThemeVariable.PRIMARY]: "#263271",
      [ThemeVariable.SECONDARY]: "#1F6FE6",
      [ThemeVariable.PRIMARY_LIGHT]: "#ECEEF9",
      [ThemeVariable.PRIMARY_LIGHTER]: "#F8F9FF",
      [ThemeVariable.PRIMARY_RGB]: "38, 50, 113",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "31, 111, 230"
    }
  },
  {
    name: UiTheme.GREEN,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#E7F9E9",
      [ThemeVariable.ACTIVE]: "#E7F9E9",
      [ThemeVariable.PRIMARY]: "#114419",
      [ThemeVariable.SECONDARY]: "#1F6FE6",
      [ThemeVariable.PRIMARY_LIGHT]: "#E7F9E9",
      [ThemeVariable.PRIMARY_LIGHTER]: "#F8FFFB",
      [ThemeVariable.PRIMARY_RGB]: "17, 68, 25",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "31, 111, 230"
    }
  },
  {
    name: UiTheme.PURPLE,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#f6e6f8",
      [ThemeVariable.ACTIVE]: "#f6e6f8",
      [ThemeVariable.PRIMARY]: "#78377E",
      [ThemeVariable.SECONDARY]: "#512d6d",
      [ThemeVariable.PRIMARY_LIGHT]: "#f6e6f8",
      [ThemeVariable.PRIMARY_LIGHTER]: "#fef8ff",
      [ThemeVariable.PRIMARY_RGB]: "120, 55, 126",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "81, 45, 109"
    }
  },
  {
    name: UiTheme.MIDNIGHT_BLUE,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#dbecfb",
      [ThemeVariable.ACTIVE]: "#dbecfb",
      [ThemeVariable.PRIMARY]: "#093a66",
      [ThemeVariable.SECONDARY]: "#ff5d24",
      [ThemeVariable.PRIMARY_LIGHT]: "#dbecfb",
      [ThemeVariable.PRIMARY_LIGHTER]: "#f0f8ff",
      [ThemeVariable.PRIMARY_RGB]: "9, 58, 102",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "255, 93, 36"
    }
  },
  {
    name: UiTheme.INDIGO,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#f4effa",
      [ThemeVariable.ACTIVE]: "#f4effa",
      [ThemeVariable.PRIMARY]: "#482972",
      [ThemeVariable.SECONDARY]: "#ff5d24",
      [ThemeVariable.PRIMARY_LIGHT]: "#f4effa",
      [ThemeVariable.PRIMARY_LIGHTER]: "#f5f3f8",
      [ThemeVariable.PRIMARY_RGB]: "72, 41, 114",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "255, 93, 36"
    }
  },
  {
    name: UiTheme.NEON_PINK,
    variables: {
      [ThemeVariable.TEXT]: "#404258",
      [ThemeVariable.HOVER]: "#fdeafa",
      [ThemeVariable.ACTIVE]: "#fdeafa",
      [ThemeVariable.PRIMARY]: "#FF00D6",
      [ThemeVariable.SECONDARY]: "#ff5d24",
      [ThemeVariable.PRIMARY_LIGHT]: "#fdeafa",
      [ThemeVariable.PRIMARY_LIGHTER]: "#fff6fe",
      [ThemeVariable.PRIMARY_RGB]: "72, 41, 114",
      [ThemeVariable.SECONDARY_LIGHT]: "#E8F0FC",
      [ThemeVariable.SECONDARY_RGB]: "255, 93, 36"
    }
  }
];
